"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionMode = exports.SelectionDirection = exports.SELECTION_CHANGE = void 0;
var utilities_1 = require("@fluentui/utilities");
Object.defineProperty(exports, "SELECTION_CHANGE", { enumerable: true, get: function () { return utilities_1.SELECTION_CHANGE; } });
Object.defineProperty(exports, "SelectionDirection", { enumerable: true, get: function () { return utilities_1.SelectionDirection; } });
Object.defineProperty(exports, "SelectionMode", { enumerable: true, get: function () { return utilities_1.SelectionMode; } });
//# sourceMappingURL=interfaces.js.map